export default class Version {
  constructor(origin) {
    this.AppVersion = origin?.AppVersion ?? "0.0.0";
    this.Build = origin?.Build;
    this.BuildVersion = origin?.BuildVersion ?? "2023-03-27T12:43:08.860Z";
  }
}
